
module.filter('studentAge', function(moment) {
    return function(student) {
        if (!angular.isDefined(student.birth_date)) return undefined;
        var date = moment.utc(student.birth_date);
        return moment().diff(date, 'years');
    };
})
